import { SentryHub } from './monitoring'

export function captureError(e: unknown) {
  SentryHub?.captureException(e)
}
